export async function save<T>(key: string, value: T): Promise<void> {
    localStorage.setItem(key, JSON.stringify(value));
}

export async function load<T>(key: string): Promise<T | null> {
    const item = localStorage.getItem(key);
    return item !== null ? JSON.parse(item) as T : null;
}